import { useMemo } from "react";
import { updateAPIClientCache } from "../../../state/actions";
import { useMakeswiftHostApiClient } from "../host-api-client";
function useCacheData(cacheData) {
  const { makeswiftApiClient: apiStore } = useMakeswiftHostApiClient();
  useMemo(() => apiStore.dispatch(updateAPIClientCache(cacheData)), [cacheData]);
}
export {
  useCacheData
};
//# sourceMappingURL=use-cache-data.js.map